import { SiteSetupService } from 'app/client-core/services/site-setup';
import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { SiteMenuModel } from 'app/client-core/dtos/site-menu.model';

@Pipe({
  name: 'siteMenuDisplayname'
})
export class SiteMenuDisplaynamePipe implements PipeTransform {
  menuTitle: string;
  constructor(
    private siteSetupService: SiteSetupService,
    private router: Router,
  ) {

  }

  transform(value: any, args?: any): any {
    const siteMenus = this.siteSetupService._getCachedSiteMenu();
    const route = this.router.url;
    console.log(route);
    return route;
  }

  setMenuTitle(menuItems: Array<SiteMenuModel>) {
    menuItems.forEach(item => {
      if (item.navLink == this.router.url.trim()) {
        this.menuTitle = item.displayName;
        console.log(item.navLink);
        console.log('route ', this.router.url);
      }
      if (item.children && item.children.length > 0) {
        this.setMenuTitle(item.children);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/site-menu-displayname.pipe.ts